export const getCatalogQuery = /* GraphQL */ `
  query GetCatalog($id: ID!) {
    getCatalog(id: $id) {
      id
      content {
        language
        time
        version
        blocks {
          data
          id
          type
          referenceID
        }
      }
      lastUpdated
      publishDate
      projectCatalogsId
      template
      metadata {
        key
        type
        value
      }
    }
  }
`
export const catalogsByProjectQuery = /* GraphQL */ `
  query CatalogsByProject(
    $projectCatalogsId: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    catalogsByProject(
      projectCatalogsId: $projectCatalogsId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      nextToken
      items {
        id
        createdAt
        metadata {
          key
          value
        }
      }
    }
  }
`

export const createCatalog = /* GraphQL */ `
  mutation CreateCatalog($input: CreateCatalogInput!) {
    createCatalog(input: $input) {
      id
      createdAt
      metadata {
        key
        value
      }
    }
  }
`

export const updateCatalog = /* GraphQL */ `
  mutation UpdateCatalog($input: UpdateCatalogInput!) {
    updateCatalog(input: $input) {
      updatedAt
    }
  }
`

export const deleteCatalog = /* GraphQL */ `
  mutation DeleteCatalog($input: DeleteCatalogInput!) {
    deleteCatalog(input: $input) {
      id
    }
  }
`
